

export default [
      'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD7.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD9.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD1.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD5.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD12.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD2.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD14.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD3.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD8.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD13.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD11.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD15.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD4.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD6.webp'
    , 'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Desteni+Devin/DD10.webp'
    
];